var ClassManager = /** @class */ (function () {
    function ClassManager() {
        this._classMap = {};
    }
    ClassManager.prototype.registerClass = function (type, clz) {
        this._classMap[type] = clz;
    };
    ClassManager.prototype.getClass = function (type) {
        return this._classMap[type];
    };
    return ClassManager;
}());
export { ClassManager };
